import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { isEmpty, uniqueId } from 'lodash/fp';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

import { WaveIcon } from '../../../assets/svg/Icon';

import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function WaveList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, handleWaveDetailList, handleOpenLegend, mobilemode,
  } = props;

  function renderList(dataList, boxClass) {
    return (
      <>
        {dataList.map((row) => (
          <Grid item key={uniqueId()}>
            <Box className={`${classes.listsBox} ${boxClass}`}>{row.name}</Box>
          </Grid>
        ))}
      </>
    );
  }

  function renderData(red) {
    return (
      <>
        {renderList(red, classes.red)}
      </>
    );
  }
  return (
    <>
      <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewForecastWave}>
        <Box display="flex" justifyContent="flex-end">
          <Box>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                {datas.count !== 0
                  ? (
                    <IconButton onClick={mobilemode ? null : handleWaveDetailList(datas)}>
                      <StyledBadge
                        id="main-wave-click"
                        badgeContent={datas.count}
                        overlap="circular"
                        color="secondary"
                      >
                        <WaveIcon style={{ color: 'white' }} />
                      </StyledBadge>
                    </IconButton>
                  ) : (
                    <StyledBadge
                      id="main-wave-click"
                      badgeContent={datas.count}
                      overlap="circular"
                      color="secondary"
                    >
                      <WaveIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  )}
              </Box>
              <Box display="flex" alignItems="center">
                <Box pl={1}>
                  <IconButton
                    id="legend_waveforecast"
                    className={classes.btn}
                    onClick={handleOpenLegend(t('เกณฑ์ข้อมูลคลื่น'), 'wave')}
                  >
                    <InfoIcon type="button" style={{ fontSize: 13, color: '#777' }} />
                  </IconButton>
                </Box>
                <Box id="dialog_wave_forecast" p={1}>
                  <NavLink id="navigate_waveforecast" to={`${initPath}wave`} activeClassName="nav-active">
                    <Typography className={classes.titleBox}>{t('คาดการณ์คลื่น')}</Typography>
                  </NavLink>
                </Box>
                <Box><Typography className={classes.timeBox}>{datas.time}</Typography></Box>
              </Box>
            </Box>
            <Box>
              <Grid id="dialog_wave_forecast_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                {isEmpty(datas) ? null
                  : (
                    <>
                      {(datas.red.length <= 0)
                        ? (
                          <Grid item>
                            <Box
                              className={`${classes.listsBox}`}
                              style={{ backgroundColor: '#FFFFFF90', fontWeight: 'bold' }}
                            >
                              {t('ปกติ')}
                            </Box>
                          </Grid>

                        ) : renderData(datas.red)}
                    </>
                  )}

              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
WaveList.defaultProps = {
  mobilemode: false,
};

WaveList.propTypes = {
  datas: PropTypes.objectOf(Object).isRequired,
  handleWaveDetailList: PropTypes.func.isRequired,
  handleOpenLegend: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
